import type { ClassValue } from "clsx"

import { cn } from "@be-miniapp/ui/lib/utils"

interface BackdropProps {
  className?: ClassValue
  onBackdropClick?: () => void
}

const Backdrop = ({ className, onBackdropClick }: BackdropProps) => {
  return (
    <div
      className={cn("fixed inset-0 z-[100] bg-gray-900/80", className)}
      onClick={onBackdropClick}
    ></div>
  )
}

export { Backdrop }
